var SENTRY_RELEASE;SENTRY_RELEASE={name: "Haniverse", version: "1.0.0"};